// extracted by mini-css-extract-plugin
export default {"OTALogo":"OTALogo_OTALogo__NmZhY","OTALogo__flex":"OTALogo_OTALogo__flex__YjdkM","OTALogo__asset":"OTALogo_OTALogo__asset__YzUxY","OTALogo__image":"OTALogo_OTALogo__image__ZDMxY"};